import React, { useState, useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';

var BUTTON_TYPE;
(function (BUTTON_TYPE) {
    BUTTON_TYPE["PRIMARY"] = "isPrimary";
    BUTTON_TYPE["SECONDARY"] = "isSecondary";
    BUTTON_TYPE["ADVANCED"] = "isAdvanced";
    BUTTON_TYPE["LINK"] = "isLink";
    BUTTON_TYPE["PLAIN"] = "isPlain";
    BUTTON_TYPE["DANGER"] = "isDanger";
    BUTTON_TYPE["SUCCESS"] = "isSuccess";
})(BUTTON_TYPE || (BUTTON_TYPE = {}));
var BUTTON_HTML_TYPE;
(function (BUTTON_HTML_TYPE) {
    BUTTON_HTML_TYPE["BUTTON"] = "button";
    BUTTON_HTML_TYPE["SUBMIT"] = "submit";
    BUTTON_HTML_TYPE["RESET"] = "reset";
})(BUTTON_HTML_TYPE || (BUTTON_HTML_TYPE = {}));
var BUTTON_SIZE;
(function (BUTTON_SIZE) {
    BUTTON_SIZE["DEFAULT"] = "isDefault";
    BUTTON_SIZE["BIG"] = "isBig";
})(BUTTON_SIZE || (BUTTON_SIZE = {}));
class Button extends React.Component {
}

// White, black and gray
const white = 'hsl(0, 0%, 100%)';
const gray95 = 'hsl(0, 0%, 95%)';
const gray80 = 'hsl(0, 0%, 80%)';
const gray20 = 'hsl(0, 0%, 20%)';

// Color variables
const actionColor = 'hsl(210, 100%, 50%)';
const errorColor = 'hsl(0, 85%, 55%)';
const successColor = 'hsl(150, 100%, 35%)';

// Base sizes (px)
const lineHeight = 36;
const spacing = 4;
const fontNormal = 14;
const fontNormalBig = 16;

// App  = utils (px)
const borderRadius = 8;

const spin = keyframes `
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
`;
const StyledButton = styled.button.attrs((props) => ({
    disabled: props.isDisabled || props.isLoading,
})) `
    display: inline-flex;
    align-items: center;
    font-weight: 400;
    cursor: pointer;
    height: ${lineHeight}px;
    line-height: ${lineHeight}px;
    font-size: ${fontNormal}px;
    padding: 0 ${spacing * 4}px;
    justify-content: center;
    white-space: nowrap;
    user-select: none;
    border: 0;
    border-radius: ${borderRadius}px;
    transition: background-color 0.1s linear 0s, border-color 0.1s linear 0s;
    outline: none;
      
    ${(props) => {
    var _a, _b, _c, _d, _e, _f;
    return props.styledType === BUTTON_TYPE.PRIMARY && css `
        background-color: ${((_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.actionColor) === null || _b === void 0 ? void 0 : _b.main) || actionColor};
        color: ${white};
        
        &:hover {
            background-color: ${((_d = (_c = props.theme) === null || _c === void 0 ? void 0 : _c.actionColor) === null || _d === void 0 ? void 0 : _d.hover) || 'hsl(210, 100%, 60%)'};
            color: ${white};
        }
        
        &:active {
            background-color: ${((_f = (_e = props.theme) === null || _e === void 0 ? void 0 : _e.actionColor) === null || _f === void 0 ? void 0 : _f.active) || 'hsl(210, 100%, 45%)'};
            color: ${white};
        }
    `;
}}

    ${(props) => props.styledType === BUTTON_TYPE.SECONDARY && css `
        background-color: ${white};
        color: ${gray20};
        box-shadow: inset 0 0 0 1px ${gray80};
        
        &:hover {
            background-color: hsl(0, 0%, 90%);
            box-shadow: inset 0 0 0 1px grey;
            color: black;
        }
        
        &:active {
            background-color: hsl(0, 0%, 95%);
            color: ${gray20};
        }
    `}
    
    ${(props) => {
    var _a, _b, _c;
    return props.styledType === BUTTON_TYPE.ADVANCED && css `
        background-color: white;
        color: ${((_a = props.theme.actionColor) === null || _a === void 0 ? void 0 : _a.main) || actionColor};
        box-shadow: inset 0 0 0 1px ${((_c = (_b = props.theme) === null || _b === void 0 ? void 0 : _b.actionColor) === null || _c === void 0 ? void 0 : _c.main) || actionColor};
      
        &:hover {
          box-shadow: inset 0 0 0 1px hsl(210, 100%, 45%);
        }
        
        &:active {
          box-shadow: inset 0 0 0 1px hsl(210, 100%, 40%);
        }
    `;
}}
    
    ${(props) => props.styledType === BUTTON_TYPE.LINK && css `
        background-color: transparent;
        color: ${actionColor};
        line-height: inherit;
        height: auto;
        padding: 0;
        border: 0;
     
        &:hover {
            color: hsl(210, 100%, 20%); 
        }
        
        &:disabled {
            background-color: transparent !important;
        }
    `}
    
    ${(props) => props.styledType === BUTTON_TYPE.PLAIN && css `
        height: auto;
        padding: 0;
        background: transparent;
        border-radius: 0;
        line-height: 1;
        font-weight: normal;
      
        &:hover {
        }
        
        &:active {
        }
        
        &:disabled {
            background-color: transparent !important;
        }
    `}
    
    ${(props) => {
    var _a, _b, _c, _d, _e, _f;
    return props.styledType === BUTTON_TYPE.DANGER && css `
        background-color: ${((_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.errorColor) === null || _b === void 0 ? void 0 : _b.main) || errorColor};
        color: ${white};
    
        &:hover {
          background-color: ${((_d = (_c = props.theme) === null || _c === void 0 ? void 0 : _c.errorColor) === null || _d === void 0 ? void 0 : _d.hover) || 'hsl(360, 85%, 40%)'};
        }
        
        &:active {
          background-color: ${((_f = (_e = props.theme) === null || _e === void 0 ? void 0 : _e.errorColor) === null || _f === void 0 ? void 0 : _f.active) || 'hsl(360, 85%, 40%)'};
        }
    `;
}}
    
    ${(props) => {
    var _a, _b, _c, _d, _e, _f;
    return props.styledType === BUTTON_TYPE.SUCCESS && css `
        background-color: ${((_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.successColor) === null || _b === void 0 ? void 0 : _b.main) || successColor};
        color: ${white};
        
        &:hover {
            background-color: ${((_d = (_c = props.theme) === null || _c === void 0 ? void 0 : _c.successColor) === null || _d === void 0 ? void 0 : _d.hover) || 'hsl(150, 100%, 25%)'};
            color: ${white};
        }
        
        &:active {
            background-color: ${((_f = (_e = props.theme) === null || _e === void 0 ? void 0 : _e.successColor) === null || _f === void 0 ? void 0 : _f.active) || 'hsl(150, 100%, 25%)'};
            color: ${white};
        }
    `;
}}
    
    ${(props) => props.size === BUTTON_SIZE.BIG && css `
        height: ${lineHeight * 2}px;
        line-height: ${lineHeight * 2}px;
        padding: 0 24px;
        font-size: ${fontNormalBig}px;
    `}
    
    ${(props) => props.isLoading && css `
        cursor: progress !important;
        position: relative;
        color: transparent;
        
        &:before {
            content: '';
            position: absolute;
            height: 20px;
            width: 20px;
            border: 3px solid;
            border-color: white ${gray80} ${gray80};
            opacity: 0.7;
            border-radius: 50%;
            animation: ${spin} 0.5s linear infinite;
            margin-left: auto;
            margin-right: auto;
        }
        
        &:hover {
             color: transparent;
        } 
    `}
    
    ${(props) => props.isDisabled && css `
        cursor: not-allowed !important;
        background-color: ${gray95} !important;
        box-shadow: none !important;;
        color: gray !important;
        
        &:hover {
            box-shadow: none !important;;
        }
    `}

    ${(props) => props.isFullWidth && css `
        width: 100%;
    `}
`;

const Button$1 = ({ isLoading = false, htmlType = BUTTON_HTML_TYPE.BUTTON, type = BUTTON_TYPE.PLAIN, size = BUTTON_SIZE.DEFAULT, onClick, isFullWidth = false, elementId, isAsync = false, isDisabled = false, children, gtmAction = undefined, gtmLabel = undefined, onMouseEnter = undefined, onMouseLeave = undefined, }) => {
    const [isStateLoading, setLoading] = useState(isLoading);
    const isMounted = React.useRef(true);
    useEffect(() => () => {
        isMounted.current = false;
    }, []);
    useEffect(() => {
        setLoading(isLoading);
    }, [isLoading]);
    async function onClickAsync() {
        try {
            setLoading(true);
            await onClick();
        }
        finally {
            if (isMounted.current) {
                setLoading(false);
            }
        }
    }
    function onClickLocal() {
        if (!isAsync) {
            onClick();
            return;
        }
        onClickAsync();
    }
    return (React.createElement(StyledButton, { type: htmlType, styledType: type, size: size, onClick: onClickLocal, isDisabled: isStateLoading || isDisabled, id: elementId, className: "Button", "gtm-action": gtmAction, "gtm-label": gtmLabel, "data-is-loading": isStateLoading, isLoading: isLoading || isStateLoading, isFullWidth: isFullWidth, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, children));
};

export default Button$1;
export { BUTTON_HTML_TYPE, BUTTON_SIZE, BUTTON_TYPE };
